import { DetailsModal } from '@sidecar/common/components/DetailsModal';
import { GlobalSearchTaskDetailsModalContent } from './GlobalSearchTaskDetailsModalContent';

interface GlobalSearchTaskDetailsModalProps {
  taskId: string | null;
  onClose: () => void;
}

export const GlobalSearchTaskDetailsModal = ({
  taskId,
  onClose,
}: GlobalSearchTaskDetailsModalProps) => (
  <DetailsModal isOpen={!!taskId} onClose={onClose}>
    {taskId && (
      <GlobalSearchTaskDetailsModalContent
        key={taskId}
        taskId={taskId}
        onClose={onClose}
      />
    )}
  </DetailsModal>
);
